import { Routes, Route } from 'react-router-dom';
import ModuleDashboardPage from './pages/ModuleDashboardPage';
import DashboardBuilderPage from './pages/DashboardBuilderPage';

const ModuleDashboardRoutes = () => (
  <Routes>
    <Route path="/" element={<ModuleDashboardPage />} />
    <Route path="/builder" element={<DashboardBuilderPage />} />
  </Routes>
);

export default ModuleDashboardRoutes;
